/* ==========================================================================
   SKIN BY RAINA — theme behaviour
   Sticky header state, mobile drawer, scroll reveal, native .ics export.
   ========================================================================== */
(function () {
  'use strict';

  /* -- Sticky header ------------------------------------------------------ */
  var hdr = document.querySelector('[data-header]');
  if (hdr) {
    var stuck = false;
    var onScroll = function () {
      var next = window.scrollY > 24;
      if (next !== stuck) { stuck = next; hdr.setAttribute('data-stuck', String(stuck)); }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* -- Mobile drawer ------------------------------------------------------ */
  var burger = document.querySelector('[data-burger]');
  var drawer = document.querySelector('[data-drawer]');
  if (burger && drawer) {
    var setOpen = function (open) {
      burger.setAttribute('aria-expanded', String(open));
      drawer.setAttribute('data-open', String(open));
      document.documentElement.style.overflow = open ? 'hidden' : '';
    };
    burger.addEventListener('click', function () {
      setOpen(burger.getAttribute('aria-expanded') !== 'true');
    });
    drawer.addEventListener('click', function (e) {
      if (e.target.tagName === 'A') setOpen(false);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') setOpen(false);
    });
    /* Rotate to landscape past the burger breakpoint and the open drawer
       would cover a page with no visible way to close it. */
    var wide = window.matchMedia('(min-width: 56rem)');
    var onWide = function (e) { if (e.matches) setOpen(false); };
    if (wide.addEventListener) wide.addEventListener('change', onWide);
    else if (wide.addListener) wide.addListener(onWide);
  }

  /* -- Scroll reveal ------------------------------------------------------ */
  var targets = document.querySelectorAll('[data-reveal]');
  if (targets.length) {
    if (!('IntersectionObserver' in window) ||
        window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      targets.forEach(function (el) { el.classList.add('is-in'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          var delay = parseInt(en.target.getAttribute('data-reveal-delay') || '0', 10);
          setTimeout(function () { en.target.classList.add('is-in'); }, delay);
          io.unobserve(en.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
      targets.forEach(function (el) { io.observe(el); });
    }
  }

  /* -- "Other" checkboxes reveal their free-text box ---------------------- */
  document.querySelectorAll('.other-toggle').forEach(function (cb) {
    var box = document.getElementById(cb.dataset.target);
    if (!box) return;
    cb.addEventListener('change', function () {
      box.hidden = !cb.checked;
      if (cb.checked) box.focus();
    });
  });

  /* -- Inline examples ----------------------------------------------------
     Grid-rows animation rather than max-height, so the panel opens to its
     real height without a magic number.                                    */
  document.querySelectorAll('[data-example]').forEach(function (btn) {
    var panel = document.getElementById(btn.getAttribute('aria-controls'));
    if (!panel) return;
    btn.addEventListener('click', function () {
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!open));
      panel.setAttribute('data-open', String(!open));
      btn.textContent = open
        ? btn.dataset.labelClosed || btn.textContent
        : (btn.dataset.labelOpen || 'Hide example');
    });
    btn.dataset.labelClosed = btn.textContent.trim();
  });

  /* -- "See an example" from elsewhere on the page -----------------------
     Opens the first guide example and scrolls to it, rather than repeating
     the whole guide in a second place.                                     */
  document.querySelectorAll('[data-open-example]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var guide = document.querySelector('.example__panel .guide');
      var panel = guide && guide.closest('.example__panel');
      if (!panel) return;
      var toggle = document.querySelector('[aria-controls="' + panel.id + '"]');
      if (toggle && toggle.getAttribute('aria-expanded') !== 'true') toggle.click();
      panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  /* -- Add to calendar ----------------------------------------------------
     Builds an .ics client-side from data attributes so a confirmed booking
     lands in the client's phone calendar with no third-party service.      */
  function pad(n) { return String(n).padStart(2, '0'); }
  function stamp(d) {
    return d.getUTCFullYear() + pad(d.getUTCMonth() + 1) + pad(d.getUTCDate()) + 'T' +
           pad(d.getUTCHours()) + pad(d.getUTCMinutes()) + '00Z';
  }
  function esc(s) {
    return String(s || '').replace(/([,;\\])/g, '\\$1').replace(/\n/g, '\\n');
  }

  document.querySelectorAll('[data-ics]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var m = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})$/.exec(btn.getAttribute('data-ics-start') || '');
      if (!m) return;
      var start = new Date(+m[1], +m[2] - 1, +m[3], +m[4], +m[5]);
      var mins = parseInt(btn.getAttribute('data-ics-minutes') || '60', 10);
      var end = new Date(start.getTime() + mins * 60000);

      var ics = [
        'BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//Skin by Raina//EN',
        'CALSCALE:GREGORIAN', 'METHOD:PUBLISH', 'BEGIN:VEVENT',
        'UID:' + (btn.getAttribute('data-ics-uid') || start.getTime()) + '@skinbyraina',
        'DTSTAMP:' + stamp(new Date()),
        'DTSTART:' + stamp(start),
        'DTEND:' + stamp(end),
        'SUMMARY:' + esc(btn.getAttribute('data-ics-title') || 'Appointment at Skin by Raina'),
        'DESCRIPTION:' + esc(btn.getAttribute('data-ics-desc') || ''),
        'LOCATION:' + esc(btn.getAttribute('data-ics-location') || ''),
        'BEGIN:VALARM', 'TRIGGER:-PT24H', 'ACTION:DISPLAY',
        'DESCRIPTION:Appointment tomorrow with Raina', 'END:VALARM',
        'END:VEVENT', 'END:VCALENDAR'
      ].join('\r\n');

      var url = URL.createObjectURL(new Blob([ics], { type: 'text/calendar;charset=utf-8' }));
      var a = document.createElement('a');
      a.href = url;
      a.download = 'skin-by-raina.ics';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      setTimeout(function () { URL.revokeObjectURL(url); }, 2000);
    });
  });
})();
